var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "59px",
    viewBox: "0 0 55 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Abstract/05",
    transform: "translate(-5.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,57 C16.3856,57 11,51.6192 11,45 C11,38.3808 16.3856,33 23,33 C29.6144,33 35,38.3808 35,45 C35,51.6192 29.6144,57 23,57 M23,28 C13.6111429,28 6,35.6111429 6,45 C6,54.3888571 13.6111429,62 23,62 C32.3888571,62 40,54.3888571 40,45 C40,35.6111429 32.3888571,28 23,28",
    id: "Fill-1",
    fill: "#EEBAD4",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,21 C41,17.1406667 44.1406667,14 48,14 C51.8593333,14 55,17.1406667 55,21 C55,24.8593333 51.8593333,28 48,28 C44.1406667,28 41,24.8593333 41,21 M60,21 C60,14.3712 54.6288,9 48,9 C41.3712,9 36,14.3712 36,21 C36,27.6288 41.3712,33 48,33 C54.6288,33 60,27.6288 60,21",
    id: "Fill-3",
    fill: "#EEBAD4",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7521368,23.8205128 C21.2721368,23.8205128 25.7521368,19.3405128 25.7521368,13.8205128 C25.7521368,8.30051282 21.2721368,3.82051282 15.7521368,3.82051282 C10.2321368,3.82051282 5.75213675,8.30051282 5.75213675,13.8205128 C5.75213675,19.3405128 10.2321368,23.8205128 15.7521368,23.8205128",
    id: "Path",
    className: "icon-color-base"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon05.f1a2386344ac1ce102cd95bc05656508.svg";
export { ForwardRef as ReactComponent };